import { render, staticRenderFns } from "./StatsProductDialog.vue?vue&type=template&id=eddc8e4a&scoped=true&"
import script from "./StatsProductDialog.vue?vue&type=script&lang=js&"
export * from "./StatsProductDialog.vue?vue&type=script&lang=js&"
import style0 from "./StatsProductDialog.vue?vue&type=style&index=0&id=eddc8e4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddc8e4a",
  null
  
)

export default component.exports